
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EditableProperty } from '@/modules/CMS/interfaces/checklistFields/EditableProperty';
import { EntityInfo } from '@/modules/CMS/interfaces/EntityInfo';

@Component({
    name: 'MultipleTextareas',
})
export default class MultipleTextareas extends Vue {
    @Prop({required: true}) private editableProperty!: EditableProperty;
    @Prop({required: true}) private entityInfo!: EntityInfo;
}
